import Vue from 'vue'
import router from './router'
import store from './store/index'
import '@/assets/style/element-variables.scss'
import App from './App.vue'
import API from './utils/http'
import 'weui'
import weui from 'weui.js'
import VConsole from 'vconsole'
import VueMeta from 'vue-meta'
import * as dd from 'dingtalk-jsapi'
import './utils/sensors'

Vue.use(VueMeta, {
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false

console.log(window.screen.width)

Vue.prototype.API = API
Vue.prototype.dd = dd
Vue.prototype.$weui = weui
if (process.env.VUE_APP_API_URL !== 'https://api-server.mofaxiao.com') {
  const vcon = new VConsole()
  console.log(vcon)
}

window.$vueObj = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
